module.exports = __webpack_public_path__ + "static/media/home-carosel2.7a359c26.png";